import { LOGIN_SUCCESS, SET_STORE_IP_ADDRESS } from "./actionTypes";

export const fetchLogindata = (logindata) => async (dispatch) => {
  dispatch({
    type: LOGIN_SUCCESS,
    logindata: logindata,
  });
};
export const setStoreIpAddress = (ip_address) => {
  return {
    type: SET_STORE_IP_ADDRESS,
    payload:ip_address
  }
};
